// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getAuth} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import {getStorage} from "firebase/storage"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyA2QNwp9vWtFui-X7v18mi9lBrq0i6bspU",
  authDomain: "bruinlinguists.web.app",
  projectId: "bruinlinguists-2f5cc",
  storageBucket: "bruinlinguists-2f5cc.firebasestorage.app",
  messagingSenderId: "782318645123",
  appId: "1:782318645123:web:b2a8c800519f59397bd0b6",
  measurementId: "G-V8YB97NWL8"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth=getAuth(app);
export const db=getFirestore(app)
export const storage =getStorage(app)